import { useGoogleSheets } from 'global/cnr/contexts/useHelpers/useGoogleSheets';
import { useContext, useEffect, useState } from 'react';
import { Sidebar } from 'semantic-ui-react';
import { FrameworkContext } from '../../cnr/contexts/FrameworkContent';
import GoogleSheetsProvider, { GoogleSheetsContext } from '../../cnr/contexts/GoogleSheetsContext';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { viewDataModes } from '../../cnr/reducers/DataManagmentReducer';
import { googleModeTypes, googleSheetsTypes } from '../../cnr/reducers/GoogleSheetsReducer';
import { clickOriginTypes } from '../../enums/globalEnums';
import { _allowRecreateUpdates, recreateDataHelpers } from '../../firestoreData/appData/fsRecreateData';
import MotionWait from '../../motions/MotionWait';
import FullPageWrapper from '../../wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import ConfirmationQuestion from '../alerts/ConfirmationQuestion';
import UiSaveButtons from '../buttons/UiSaveButtons';
import DataSidebar from '../swipers/DataSidebar';
import DcUpdatesList from './DcUpdatesList';
import GoogleSheetsTabs from './GoogleSheetsTabs';
import SearchInputForm from './SearchInputForm';
import TreeViewer from './TreeViewer';

export const GoogleDashboard = (props) => {

  const { handleCreate, noModal, noWizard, fromCreate, clickOriginType, googleSheetType } = props ?? {}

  let _fromDataViewer;

  switch (clickOriginType) {
    case clickOriginTypes.dataViewer:
      _fromDataViewer = true
    default:
    //nothing
  }

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fns, settings, fn_cls } = parentContext ?? {}
  const { app_state, appUser_state, eventInfo_state, paps_state, page_state, googleData_state, currentSettings_state } = states ?? {}
  const { database_fns } = fns ?? {}
  const { appUser } = appUser_state ?? {}
  const { pathViews, storageRootPath } = paps_state ?? {}
  const { homeSettings } = settings ?? {}
  const { global: homeSettings_global } = homeSettings ?? {}
  const { logging } = homeSettings_global ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { googleSheets, googleSheetsImportOptions, dataOptions, googleForms } = aps_global ?? {}
  const { googleSheetsId: googleSheetsId_existing } = googleSheets ?? {}
  const { dateFormat } = dataOptions ?? {}
  const { confirmation: confirmation_gd, updating: updating_gd, } = googleData_state ?? {}
  const { googleFormsResponseId } = googleForms ?? {}
  const { mainDb } = app_state ?? {}

  const _googleSheetsId = googleSheetType === googleSheetsTypes.registration ? googleFormsResponseId : googleSheetsId_existing

  // googleSheetsContext
  const frameworkContext = useContext(FrameworkContext)
  const { framework_state } = frameworkContext ?? {}
  const { frameworkRightType } = framework_state ?? {}

  // googleSheetsContext
  const googleSheetsContext = useContext(GoogleSheetsContext)
  const { googleSheets_state, googleSheets_handlers } = googleSheetsContext ?? {}

  const {
    activeMenuItem,
    confirmation: confirmation_gs,
    confirmationQuestion: _confirmationQuestion,
    dashboardInfo_merged,
    googleSheetsPreview,
    dcUpdates,
    googleConfirmationType,
    googleModeType,
    googleSheetsData,
    googleUpdateStatus,
    settingsViewerProps,
    showConfirmationQuestion,
    showNewOnly,
    selectedProp,
    updating: updating_gs,
  } = googleSheets_state ?? {}

  const [googleSheetsId, setGoogleSheetsId] = useState(_googleSheetsId && (_fromDataViewer || (googleModeType === googleModeTypes.previewDirect)) ? _googleSheetsId : null)
  const [viewDataMode, setViewDataMode] = useState()

  const _updating = (updating_gd || updating_gs)
  const _confirmation = confirmation_gd || confirmation_gs

  const caption = 'Data Viewer'

  const { getDataFromGoogleSheets } = useGoogleSheets()
  const callback_settings = async () => googleSheets_handlers.handleStopUpdate()

  useEffect(() => {
    if (googleSheetsImportOptions) { googleSheetsImportOptions.dateFormat = dateFormat }
    googleSheets_handlers.handleSet_updateOptions(googleSheetsImportOptions, storageRootPath, logging)
    // eslint-disable-next-line react-hooks/exhaustive-deps  
  }, []);

  useEffect(() => {
    // && !googleSheetsData
    if (googleSheetsPreview && !dashboardInfo_merged) {
      googleSheets_handlers.handleMerge_settings(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [googleSheetsPreview]);

  useEffect(() => {
    if ((viewDataMode || fromCreate)) {
      googleSheets_handlers.handleGet_settingsViewerProps(viewDataMode, fromCreate)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewDataMode, googleSheetsPreview]);

  const handleGoogleSheetKey = (gsk) => setGoogleSheetsId(gsk)

  /**
   * handles the save/update from SettingsViewer
   */
  const handleUpdate_dbSettings = async () => {

    googleSheets_handlers.handleStartUpdate()

    const { dataToUpdate, opts } = getDataToUpdate(viewDataMode)

    const updateProps = {
      viewDataMode,
      dataToUpdate,
      selectedProp
    }

    switch (viewDataMode) {

      case viewDataModes.recreateDataCollection:
      case viewDataModes.mergeDataCollection:
      case viewDataModes.addNewDataCollection:
        await recreateDataHelpers.updateCollectionsData(mainDb, database_fns, pathViews, dataToUpdate, opts, fn_cls)
        break;

      case viewDataModes.mergeDataCollections:
      case viewDataModes.recreateDataCollections:
        await recreateDataHelpers.updateCollectionsData(mainDb, database_fns, pathViews, dataToUpdate, opts, fn_cls)
        break;

      case viewDataModes.mergeDataAndSettings:
      case viewDataModes.recreateDataAndSettings:
        await recreateDataHelpers.updateCollectionsData(mainDb, database_fns, pathViews, dataToUpdate.projectData.dataCollections, opts, fn_cls)
        await recreateDataHelpers.updateSettingsData(mainDb, database_fns, pathViews, dataToUpdate.projectSettings, opts)
        googleSheets_handlers.handleStopUpdate()
        // googleSheets_handlers.handleRecreate_dataCollectionsOneByOne(null, true, false, false, true)
        break;

      case viewDataModes.mergeSettings:
      case viewDataModes.recreateGlobalSettings:
      case viewDataModes.recreateSettings:
        await recreateDataHelpers.updateSettingsData(mainDb, database_fns, pathViews, dataToUpdate, opts)
        googleSheets_handlers.handleStopUpdate()
        break;

      default:
      // nothing
    }

    googleSheets_handlers.handleStopUpdate()
  }

  const handleCancel = () => googleSheets_handlers.handleSet_googleMode(googleModeTypes.none)

  const handleGetGoogleSheet = () => {
    googleSheets_handlers.handleStartUpdate()
    getDataFromGoogleSheets({
      gsId: googleSheetsId,
      fromCreate,
      callback: googleSheets_handlers.handleResponse_googleSheet
    })
  }

  const handleGoogleChange = (e, data) => handleGoogleSheetKey(data.value)
  const handleViewDataMode = (opts) => setViewDataMode(opts ? opts.viewDataMode : null)
  const handleHideSidebar = () => !dcUpdates && handleViewDataMode()

  const confirmationQuestion = () => <ConfirmationQuestion
    {..._confirmationQuestion}
    noModal={true}
  />

  // const extractSelectedProp = (items, selectedProp, excludeNulls) => {
  //   if (excludeNulls) {
  //     return _.mapValues(
  //       _.pickBy(items, (item) => !!item[selectedProp]),
  //       (item) => ({ [selectedProp]: item[selectedProp] })
  //     );
  //   } else {
  //     return _.mapValues(items, item => ({
  //       [selectedProp]: item[selectedProp]
  //     }));
  //   }
  // };

  const extractSelectedProp = (items, selectedProp, excludeNulls) => {
    const _items = {}
    _.forEach(items, (item) => {
      const { _itemKey } = item
      _items[_itemKey] = item
    })
    if (excludeNulls) {
      return _.mapValues(
        _.pickBy(_items, (item) => !!item[selectedProp]),
        (item) => ({ [selectedProp]: item[selectedProp] })
      );
    } else {
      return _.mapValues(_items, item => ({
        [selectedProp]: item[selectedProp]
      }));
    }
  };


  /**
   * 
   * @returns a small from with the input for the google sheets id
   */
  const inputForm = () => <SearchInputForm
    disabled={!googleSheetsId}
    label='Google Sheets Key'
    onChange={handleGoogleChange}
    onClick={handleGetGoogleSheet}
    value={googleSheetsId ? googleSheetsId : ''}
  />

  const googleTabSheets = () => <GoogleSheetsTabs
    googleSheetType={googleSheetType}
    previewInfo={googleSheetsPreview}
    setViewDataMode={setViewDataMode}
    fromCreate={fromCreate}
    handleCreate={handleCreate}
    _updating={_updating}
  />

  const tabContent = () => googleSheetsPreview ? googleTabSheets() : <MotionWait origin={'GoogleDashboard'} />

  const getDataToUpdate = (createType) => {

    const _dashboardInfo_preview = _.cloneDeep(googleSheetsPreview)
    const _dashboardInfo_merged = _.cloneDeep(dashboardInfo_merged)

    if (googleSheetsPreview) {
      delete _dashboardInfo_preview._newCounts;
    }

    let _dataToUpdate = {}
    const _opts = { deletePrior: false, merge: false, allowUpdates: true }


    switch (createType) {

      case viewDataModes.addNewDataCollection:
        const activeItems = _dashboardInfo_preview?.projectData?.dataCollections[activeMenuItem]
        const newItems = _.pickBy(activeItems, { _new: true })
        _dataToUpdate = {
          [activeMenuItem]: newItems
        }
        _opts.merge = true
        break;

      // start of merge

      case viewDataModes.mergeDataCollections:
        _dataToUpdate = _.orderBy(_dashboardInfo_merged?.projectData?.dataCollections?.[activeMenuItem], ['lastName', 'name'])
        break;

      case viewDataModes.mergeSettings:
        _dataToUpdate = dashboardInfo_merged?.projectSettings
        break;

      case viewDataModes.mergeDataAndSettings:
        _dataToUpdate = _dashboardInfo_merged
        break;

      case viewDataModes.mergeDataCollection:
        let _dtu = _dashboardInfo_merged?.projectData?.dataCollections[activeMenuItem]
        console.log('_dashboardInfo_merged', _dashboardInfo_merged)
        if (selectedProp) {
          _dtu = extractSelectedProp(_dtu, selectedProp, true)
        }

        _dataToUpdate = {
          [activeMenuItem]: _dtu
        }

        console.log('_dataToUpdate', _dataToUpdate)

        _opts.merge = true

        break;

      // end of merge

      // start of recreate

      case viewDataModes.recreateDataAndSettings:
        _dataToUpdate = _dashboardInfo_preview
        _opts.deletePrior = true
        break;

      case viewDataModes.recreateDataCollection:
        _dataToUpdate = {
          [activeMenuItem]: _dashboardInfo_preview?.projectData?.dataCollections[activeMenuItem]
        }
        _opts.deletePrior = true
        break;

      case viewDataModes.recreateDataCollections:
        _dataToUpdate = _dashboardInfo_preview?.projectData?.dataCollections
        _opts.deletePrior = true
        break;

      case viewDataModes.recreateDataDocuments:
        _dataToUpdate = _dashboardInfo_preview?.projectData?.dataCollections
        _opts.deletePrior = true
        break;

      case viewDataModes.recreateGlobalSettings:
        _dataToUpdate = { global: _dashboardInfo_preview?.projectSettings?.global }
        _opts.deletePrior = true
        break;

      case viewDataModes.recreateSettings:
        _dataToUpdate = _dashboardInfo_preview?.projectSettings
        _opts.deletePrior = true
        break;

      // end of recreate

      default:
      // nothing
    }

    return { dataToUpdate: _dataToUpdate, opts: _opts }
  }

  const content_right = () => {

    const { createType, ci } = settingsViewerProps ?? {}
    const { updateCaption, updateDescription } = getUpdateDescription(createType, ci, activeMenuItem)
    const { dataToUpdate } = getDataToUpdate(createType)

    return <Wrapper
      header={updateDescription}
      content={<TreeViewer data={dataToUpdate} subNames={true} scNames={true} asSquares={false} />}
      footer={<UiSaveButtons save={{ oc: handleUpdate_dbSettings, caption: updateCaption, color: _allowRecreateUpdates ? 'green' : 'teal' }} />}
      updating={_updating}
      wrapperType={wrapperTypes.paddedHeaderAndFooter}
    />
  }

  const content_create = () => {
    if (showConfirmationQuestion && !_updating) {
      return confirmationQuestion(googleConfirmationType)
    } else {
      const showInput = (googleModeType === googleModeTypes.preview) || (googleModeType === googleModeTypes.previewDirect) || noModal || noWizard
      return <Wrapper
        header={showInput && inputForm()}
        content={googleSheetsPreview ? googleTabSheets() : <div style={{ padding: '1em' }}>No Data</div>}
        wrapperType={wrapperTypes.paddedHeaderAndFooter}
        updating={_updating}
        css={{ container: 'google-w-c' }}
      />
    }
  }

  let cn = 'wrp-sub'

  const sidebar_right = (visible) => <DataSidebar direction={'right'} visible={visible} content={visible && content_right()} onHide={handleHideSidebar} />

  const dcUpdateList = () => <DcUpdatesList dcUpdates={dcUpdates} />

  /**
   * 
   * @returns a wrapper containing a sidebar (with google sheet names) and the selected table
   */
  const wrapper = () => <Wrapper
    content={tabContent()}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
    confirmation={_confirmation}
    confirmationNoModal={fromCreate}
    updating={_updating}
    // noMid={true}
    css={{ container: cn, content: 'google-data-container' }}
  />

  const sidebar = () => <Sidebar.Pushable style={{ overflow: 'hidden' }}>
    {sidebar_right(viewDataMode ? true : false)}
    <Sidebar.Pusher dimmed={viewDataMode ? true : false} className={'h100'}>
      {wrapper()}
    </Sidebar.Pusher>
  </Sidebar.Pushable>

  const fpw_sidebar = () => <FullPageWrapper
    content={sidebar()}
    handleCancel={handleCancel}
    topperCaption={caption}
    topperCaption2={_googleSheetsId}
    noModal={!noModal}
  />

  const content_dashboard = () => {
    if (frameworkRightType) {
      return wrapper()
    } else {
      if (dcUpdates) {
        return dcUpdateList()
      } else {
        if (noWizard || fromCreate) {
          return content_create()
        } else if (_fromDataViewer) {
          return sidebar()
        } else {
          return fpw_sidebar()
        }
      }
    }
  }

  return content_dashboard()
}

const GoogleDashboardWithProvider = (props) => {
  return <GoogleSheetsProvider googleSheetsType={props.googleSheetType}>
    <GoogleDashboard {...props} />
  </GoogleSheetsProvider>
}

export default GoogleDashboardWithProvider

const getUpdateDescription = (createType, ci, activeMenuItem) => {

  let updateCaption = _.startCase(createType)
  let _updateDescription = '';

  switch (createType) {
    case viewDataModes.addNewDataCollection:
      _updateDescription = 'Add any new data collections items.'
      ci.projectCollection = null
      break;

    case viewDataModes.mergeDataCollections:
      _updateDescription = 'Merges/Updates all of the data collections.'
      ci.projectCollection = null
      break;

    case viewDataModes.mergeSettings:
      _updateDescription = 'Merges/Updates all of the existing settings (global, viewItems, views) and the settings based on the google sheet.'
      break;

    case viewDataModes.mergeDataAndSettings:
      _updateDescription = 'Merges/Updates all of the data collections and settings.'
      ci.projectCollection = null
      break;

    case viewDataModes.mergeDataCollection:
      _updateDescription = 'Updates the selected (' + activeMenuItem + ') data collection.'
      updateCaption += ' (' + _.startCase(activeMenuItem) + ')'
      break;

    case viewDataModes.recreateDataCollection:
      _updateDescription = 'Recreates the selected (' + activeMenuItem + ') data collection. This will remove the existing data.'
      updateCaption += ' (' + _.startCase(activeMenuItem) + ')'
      break;

    case viewDataModes.recreateDataCollections:
      _updateDescription = 'Recreates all of the data collections. This will remove the existing data.'
      break;

    case viewDataModes.recreateDataDocuments:
      _updateDescription = 'Recreates all of the data documents. This will remove the existing data.'
      break;

    case viewDataModes.recreateDataAndSettings:
      _updateDescription = 'Recreates all of the data collections and recreate the settings based on the google sheet. This will remove the existing data.'
      break;

    case viewDataModes.recreateGlobalSettings:
      _updateDescription = 'Recreates the global settings based on the google sheet.'


    case viewDataModes.recreateSettings:
      _updateDescription = 'Recreates the settings (global, viewItems, views) based on the google sheet.'
      break;

    default:
    // nothing
  }

  _updateDescription += ' (' + createType + ')'

  return { updateDescription: _updateDescription, updateCaption }

}